module.exports = __webpack_public_path__ + "img/banner-1-m.eff12a2f.jpg";